import HazardDetail from "@/views/mobile/sithMesII/ehs/hazard/HazardDetail.vue";
import HazardEdit from "@/views/mobile/sithMesII/ehs/hazard/HazardEdit.vue";
import HazardHome from "@/views/mobile/sithMesII/ehs/hazard/HazardHome.vue";
import HazardList from "@/views/mobile/sithMesII/ehs/hazard/HazardList.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
    {
        path: '/hazard/detail',
        component: HazardDetail,
        meta: {requiresAuth: false},
    },
    {
        path: '/hazard/edit',
        component: HazardEdit,
        meta: metaObject
    },
    {
        path: '/hazard/home',
        component: HazardHome,
        meta: {requiresAuth: false},
    },
    {
        path: '/hazard/list',
        component: HazardList,
        meta: {requiresAuth: false},
    },
]
